export default __webpack_public_path__ + "static/media/ar.038bfa8d.svg";